var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.227 11.456l6.274-6.23c.303-.301.793-.301 1.096 0l.732.726c.302.3.302.786 0 1.087L11.358 12l4.973 4.961c.301.3.3.787-.001 1.087l-.732.727c-.303.3-.793.3-1.096 0l-6.274-6.23a.766.766 0 010-1.09z",
    fill: "#56606f"
  })));
}

export default SvgChevronLeft;